import education from '@/urls/education'
import accounts from "@/urls/accounts"
import {
  postFileRequest, sendDeleteRequest,
  sendGetRequest, patchFileRequest
} from '@/helper/requests'
import { executeRequest } from '@/store/utils'

const state = {
  education: {
    advancedTrainingList: null,
    advancedTrainingDetail: null,
    loadingAdvancedTraining: false,
    currentUrl: null,
    educationDetail: null,
    loadingEducationDetail: false,
    error: null
  }
}

const getters = {
  getEducation: state => state.education.educationDetail,
  isLoadingEducationDetail: state => state.education.loadingWorkerDetail,
  saveEducationError: state => state.education.error,
  getAdvancedTrainingList: state => state.education.advancedTrainingList,
  isLoadingAdvancedTraining: state => state.education.loadingAdvancedTraining
}

const actions = {
  loadEducation: ({ commit }, { url, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает данные об образовании
     * @param {Object} context - контекст Vuex
     * @param {string} url - URL для загрузки (опционально)
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    commit('SET_EDUCATION_DETAIL_LOADING')
    if (!url) url = accounts.PROFILE.STUDENT()
    sendGetRequest(
      url, (data, url) => {
        data = data.sort(function (a, b) {
          if (a.active < b.active) {
            return 1
          }
          if (a.active > b.active) {
            return -1
          }
          return 0
        })
        commit('SET_EDUCATION_DETAIL', data)
        commit('SET_EDUCATION_DETAIL_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_EDUCATION_ERROR', data)
        commit('SET_EDUCATION_DETAIL_LOADING_END')
        catcher(data, url)
      }
    )
  },
  loadAdvancedTraining: ({ commit }, { url, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает список пройденных курсов дополнительного образования
     * @param {Object} context - контекст Vuex
     * @param {string} url - URL для загрузки (опционально)
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    commit('SET_ADVANCEDTRAINING_LOADING')
    if (!url) url = education.EDUCATION.ADVANCED_TRAINING.LIST()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_ADVANCEDTRAINING_LIST', data)
        commit('SET_ADVANCEDTRAINING_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_ADVANCEDTRAINING_ERROR', data)
        commit('SET_ADVANCEDTRAINING_LOADING_END')
        catcher(data, url)
      }
    )
  },
  changeAdvancedTraining: ({ dispatch, commit, getters }, { data, id, finalizer, catcher }) => {
    /**
     * Изменяет данные курса дополнительного образования
     * @param {Object} context - контекст Vuex
     * @param {Object} data - данные для обновления
     * @param {string|number} id - идентификатор курса
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = education.EDUCATION.ADVANCED_TRAINING.UPDATE(id)
    executeRequest('AdvancedTraining', patchFileRequest, { url, data, finalizer, catcher }, { dispatch, commit, getters })
  },
  deleteAdvancedTraining: ({ dispatch, commit, getters }, { data, finalizer, catcher }) => {
    /**
     * Удаляет курс дополнительного образования
     * @param {Object} context - контекст Vuex
     * @param {Object} data - данные курса
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = education.EDUCATION.ADVANCED_TRAINING.DELETE(data.id)
    executeRequest('AdvancedTraining', sendDeleteRequest, { url, data, finalizer, catcher }, { dispatch, commit, getters })
  },
  createAdvancedTraining: ({ dispatch, commit, getters }, { data, finalizer, catcher }) => {
    /**
     * Создает новый курс дополнительного образования
     * @param {Object} context - контекст Vuex
     * @param {Object} data - данные нового курса
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = education.EDUCATION.ADVANCED_TRAINING.CREATE()
    executeRequest('AdvancedTraining', postFileRequest, { url, data, finalizer, catcher }, { dispatch, commit, getters })
  }
}

const mutations = {
  SET_EDUCATION_DETAIL: (state, value) => {
    /**
     * Устанавливает данные об образовании
     * @param {Object} state - состояние хранилища
     * @param {Array} value - массив данных об образовании
     */
    state.education.educationDetail = value
  },
  SET_EDUCATION_DETAIL_LOADING: (state) => {
    /**
     * Включает состояние загрузки данных об образовании
     * @param {Object} state - состояние хранилища
     */
    state.education.loadingEducationDetail = true
  },
  SET_EDUCATION_DETAIL_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки данных об образовании
     * @param {Object} state - состояние хранилища
     */
    state.education.loadingEducationDetail = false
  },
  SET_ADVANCEDTRAINING_LIST: (state, value) => {
    /**
     * Устанавливает список курсов дополнительного образования
     * @param {Object} state - состояние хранилища
     * @param {Array} value - массив курсов
     */
    state.education.advancedTrainingList = value
  },
  SET_ADVANCEDTRAINING_DETAIL: (state, value) => {
    /**
     * Устанавливает детальную информацию о курсе
     * @param {Object} state - состояние хранилища
     * @param {Object} value - данные курса
     */
    state.education.advancedTrainingDetail = value
  },
  SET_ADVANCEDTRAINING_LOADING: (state) => {
    /**
     * Включает состояние загрузки курсов
     * @param {Object} state - состояние хранилища
     */

    state.education.loadingAdvancedTraining = true
  },
  SET_ADVANCEDTRAINING_LOADING_END: (state) => {
    /**
     * Выключает состояние загрузки курсов
     * @param {Object} state - состояние хранилища
     */
    state.education.loadingAdvancedTraining = false
  },
  SAVE_ADVANCEDTRAINING_ERROR: (state, error) => {
    /**
     * Сохраняет ошибку при работе с курсами
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.education.error = error
  },
  SAVE_EDUCATION_ERROR: (state, error) => {
    /**
     * Сохраняет ошибку при работе с данными об образовании
     * @param {Object} state - состояние хранилища
     * @param {Object} error - объект ошибки
     */
    state.education.error = error
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
